<script>
import _ from 'lodash';

import RtCardV1 from './rtCard.vue';
import RtCardV2 from './rtCardV2.vue';
import RtNode from '../node/rtNode.vue';
import RtSection from '../section/rtSection.vue';

export default {
  name: 'RtCardNew',

  props: {
    xpcVersion: {
      type: String,
      default: 'v1'
    }
  },

  data () {
    return {
      /**
       * @private
       *
       * 用于透传的ref对象
       */
      proxyRef: undefined
    };
  },

  computed: {
    component () {
      switch (this.xpcVersion) {
        case 'v1':
          return RtCardV1;
        case 'v2':
          return RtCardV2;
        case 'node':
          return RtNode;
        case 'section':
          return RtSection;
        default:
          return 'div';
      }
    }
  },

  created () {
    this._proxySlotsUsage();
  },

  mounted () {
    this._proxyRefUsage();
  },

  methods: {
    /**
     * @private
     *
     * 对父元素使用slot的情况进行属性透传，此函数需要在created时进行
     */
    _proxySlotsUsage () {
      Object.defineProperty(this.$refs, 'proxyRef', {
        get: () => this.proxyRef,
        set: ref => {
          this.proxyRef = _.merge(ref, { $slots: this.$slots });
        }
      });
    },

    /**
     * @private
     *
     * 查找当前组件被ref指向的节点对象
     */
    _findRefOwner (curNode, dstNode) {
      let refKey;
      let refOwner;

      if (curNode && curNode.$refs) {
        const _key = Object.keys(curNode.$refs).find(key => {
          if (Array.isArray(curNode.$refs[key])) {
            // 暂不考虑ref为数组的情况
            return false;
          } else {
            return curNode.$refs[key] === dstNode;
          }
        });

        if (_key) {
          refKey = _key;
          refOwner = curNode;
        } else {
          // 递归查找父节点
          const res = this._findRefOwner(curNode.$parent, dstNode);

          refKey = res.refKey;
          refOwner = res.refOwner;
        }
      }

      return { refKey, refOwner };
    },

    /**
     * @private
     *
     * 对父元素使用ref的情况进行属性透传，此函数需要在mounted时进行
     */
    _proxyRefUsage () {
      const { refKey, refOwner } = this._findRefOwner(this.$parent, this);

      if (refKey && refOwner) {
        refOwner.$refs[refKey] = new Proxy(this, {
          get: (target, key) => {
            if (key.startsWith('xpc')) {
              return this[key];
            } else if (key === '$owner') {
              return this;
            } else if (key.startsWith('$owner_')) {
              return this[key.replace('$owner_', '')];
            } else {
              return this.$refs.proxyRef[key];
            }
          }
        });
      }
    }
  },

  render (h) {
    const data = {
      ref: 'proxyRef',
      props: this.$attrs,
      on: this.$listeners,
      scopedSlots: this.$scopedSlots
    };

    return h(this.component, data, this.$children);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?4716c048